import { render } from "./ClientControlAccesoRoles.vue?vue&type=template&id=aad4a962&scoped=true"
import script from "./ClientControlAccesoRoles.vue?vue&type=script&lang=js"
export * from "./ClientControlAccesoRoles.vue?vue&type=script&lang=js"

import "./ClientControlAccesoRoles.vue?vue&type=style&index=0&id=aad4a962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad4a962"]])

export default __exports__